module.exports = __webpack_public_path__ + "static/media/Vidanta.98bb6621.png";